// @flow
import * as React from "react";
import Gettext from "../../common/Gettext";
import HowMuchInBucks from "../../HowMuchInBucks";
import * as S from "./styles";
import { StyledPopup as Popup } from "./Popup";
import Link from "../Link";
import { FlatButton } from "../../Buttons";
import Tournament from "../Api";
import Spinner from "../../Spinners/SimpleSpinner";
import * as custom from "../../common/customConsole";
import idx from "idx";
import { getRefillCosts } from "../helpers/refill";

type HideProps = { all?: boolean, callback: () => void };

type Props = {
  in: boolean,
  onDismiss: (hide: HideProps) => void,
  onDismissAll: () => void,
  style?: string,
  api: any
};

class RefillPopup extends React.Component<Props, {}> {
  onRefillClick = async (id: number) => {
    const { api, onDismiss } = this.props;

    onDismiss();

    try {
      const refill = await api.fetchEntity(
        `/api/tournaments/refill?tournament_id=${id}`
      );

      if (refill.value != null) {
        api.fetchEntity("/api/tournaments/list?status=1");
        api.fetchEntity(
          "/api/tournaments/list?status=1&participation_status=1"
        );
        api.fetchEntity(`/api/tournaments/info?id=${id}`);
        api.fetchEntity("/api/tournaments/stats");
        onDismiss({
          all: true
        });
      }

    } catch (error) {
      custom.error(error);
    }
  };

  componentDidMount() {
    this.props.api.fetchEntity("/api/tournaments/stats");
  }

  render() {
    const { in: inProp, onDismiss, style, api } = this.props;
    const fades = this.props.onDismissAll == null ? true : false;

    const stats = idx(
      api.readEntity("/api/tournaments/stats"),
      stats => stats.value
    );

    if (stats == null) {
      return (
        <Popup style={style} in={inProp} fades={fades} onDismiss={onDismiss}>
          <S.Wrapper>
            <Spinner accent />
          </S.Wrapper>
        </Popup>
      );
    }

    const current_tournament = idx(stats, stats => stats.active_tournament);

    if (
      current_tournament == null ||
      !current_tournament.refill ||
      !current_tournament.refill_costs
    ) {
      return null;
    }

    const { cost_usd, cost } = getRefillCosts(current_tournament);

    return (
      <Popup style={style} in={inProp} fades={fades} onDismiss={onDismiss}>
        <S.Wrapper>
          <S.MobileWrapper>
            <S.Title>
              <Gettext>Top up a tournament account balance by</Gettext>:
            </S.Title>
            <S.Footer>
              <S.MoneyContainer>
                {cost_usd != null &&
                cost != null &&
                Number(cost_usd) > 0 &&
                Number(cost) > 0 ? (
                  <HowMuchInBucks
                    value={cost}
                    valueUSD={cost_usd}
                    valueStyle={S.Value}
                    symbolStyle={S.Currency}
                  />
                ) : (
                  <S.Free>
                    <Gettext>Free</Gettext>
                  </S.Free>
                )}
              </S.MoneyContainer>
              <S.Content>
                <Gettext>
                  The funds will be deducted from your account for use in the
                  tournament
                </Gettext>
              </S.Content>
              <FlatButton
                type="trade"
                onClick={() => this.onRefillClick(current_tournament.id)}
              >
                <Gettext>Refill</Gettext>
              </FlatButton>
            </S.Footer>
          </S.MobileWrapper>
          <Link to="/conditions">
            <Gettext>Terms & Conditions</Gettext>
          </Link>
        </S.Wrapper>
      </Popup>
    );
  }
}

export default props => (
  <Tournament.Consumer>
    {api => {
      const stats = idx(
        api.readEntity("/api/tournaments/stats"),
        stats => stats.value
      );
      const current_tournament = idx(stats, stats => stats.active_tournament);

      if (stats == null || current_tournament == null) {
        return null;
      }

      return <RefillPopup {...props} api={api} key={current_tournament.id} />;
    }}
  </Tournament.Consumer>
);



// WEBPACK FOOTER //
// ./src/components/Tournaments/Popups/Refill.js